import I from 'components/I'
import * as PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { platform } from 'utils'
import Btn from '../buttons/Btn'
import Order from 'state/models/Order'
import { useAlertActions } from './actions'

/**
 * @param title
 * @param children
 * @param link
 * @param btnText
 * @param id
 * @param superClose
 * @returns {*}
 * @constructor
 * @internal Not intended to be used outside of the Alerts component
 */
export default function FlashAlert ({ title, children = null, link = null, btnText = 'Open', id = null, onClose: superClose = null }) {
	const { t }              = useTranslation()
	const [onClick, onClose] = useAlertActions(id, link, superClose)
	return (
		<div className="alert-flashing" onClick={onClose}>
			<h1 className="mb-4">{title}</h1>
			{children && <div className="content">{children}</div>}
			{link !== '' && <Btn size="lg" variant="secondary" onClick={onClick} swap
			                     icon={Order.ICONS[Order.STATUS.ACTIVE].icon}>{btnText}</Btn>}
			<I en className="mt-3">{t('({{clickOrTap}} anywhere to dismiss)', { clickOrTap: platform.clickOrTap(t) })}</I>
		</div>
	)
}
FlashAlert.propTypes    = {
	title  : PropTypes.node,
	btnText: PropTypes.string,
	link   : PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	id     : PropTypes.number,
	onClose: PropTypes.func,
}

//TODO add some recalculation method when the device orientation changes, and maybe on window resizing as well
const LARGE = window.innerWidth >= 378
/** Roughly the height of the other elements, divided by overall line height */
FlashAlert.MAX_ORDERS = Math.floor((window.innerHeight - (LARGE? 320 : 280)) / (LARGE? 35 : 30))
